import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import TabIcon from './TabIcon';
import { useNavigateWithParams } from '../utils/navigationUtils';
import '../styles/bottom-navigation.css';

interface BottomNavigationProps {
  showTaskList: boolean;
  showTeam: boolean;
  showLedger: boolean;
  showTarget: boolean;
}

const BottomNavigation: React.FC<BottomNavigationProps> = ({ 
  showTaskList, 
  showTeam, 
  showLedger, 
  showTarget 
}) => {
  const navigateWithParams = useNavigateWithParams();
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="bottom-nav-container">
      <button
        onClick={() => navigateWithParams('/')}
        className={`bottom-nav-button ${isActive('/') ? 'active' : ''}`}
      >
        {isActive('/') && (
          <div className="bottom-nav-active-indicator" />
        )}
        <TabIcon name="Home" focused={isActive('/')} size={24} />
        <div className="bottom-nav-label">Home</div>
      </button>
      
      {showTaskList && (
        <button
          onClick={() => navigateWithParams('/tasks')}
          className={`bottom-nav-button ${isActive('/tasks') ? 'active' : ''}`}
        >
          {isActive('/tasks') && (
            <div className="bottom-nav-active-indicator" />
          )}
          <TabIcon name="TaskList" focused={isActive('/tasks')} size={24} />
          <div className="bottom-nav-label">Tasks</div>
        </button>
      )}
      
      {showTarget && (
        <button
          onClick={() => navigateWithParams('/targets')}
          className={`bottom-nav-button ${isActive('/targets') ? 'active' : ''}`}
        >
          {isActive('/targets') && (
            <div className="bottom-nav-active-indicator" />
          )}
          <TabIcon name="Target" focused={isActive('/targets')} size={24} />
          <div className="bottom-nav-label">Targets</div>
        </button>
      )}
      
      {showTeam && (
        <button
          onClick={() => navigateWithParams('/team')}
          className={`bottom-nav-button ${isActive('/team') ? 'active' : ''}`}
        >
          {isActive('/team') && (
            <div className="bottom-nav-active-indicator" />
          )}
          <TabIcon name="Team" focused={isActive('/team')} size={24} />
          <div className="bottom-nav-label">Team</div>
        </button>
      )}
      
      <button
        onClick={() => navigateWithParams('/profile')}
        className={`bottom-nav-button ${isActive('/profile') ? 'active' : ''}`}
      >
        {isActive('/profile') && (
          <div className="bottom-nav-active-indicator" />
        )}
        <TabIcon name="Profile" focused={isActive('/profile')} size={24} />
        <div className="bottom-nav-label">Profile</div>
      </button>
      

    </nav>
  );
};

export default BottomNavigation;